import Modal from "react-bootstrap/Modal";
import React from "react";
import Button from "react-bootstrap/Button";
import { Chip } from "@mui/material";
import { AzureStorageManage } from "../../../helper/azureStorageManage";
import { namespace } from "../../../helper/namespace";
import { sweetStatusAlert } from "../../common/SweetAlert";

const DocModal = ({docModal, toggleDocModal, uploadType}) => {
    
    const truncateFileName = (fileName) => {
        const maxLength = 25;
        if (fileName?.length > maxLength) {
        return "..." + fileName.substring(fileName.length - maxLength);
        }
        return fileName;
    };
    
    const handleSelectedFileDownload = async (container_id, blobName) => {
        try {
            await AzureStorageManage.downloadBlob(container_id, blobName)
        } catch (error) {
            sweetStatusAlert(namespace.SUCCESS, `File downloaded successfully!!!`, "success")            
        }
    }
    return (
        
        <div>
            <Modal
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={docModal}
                onHide={() => toggleDocModal()}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                    {" "}
                        <h3>
                            {uploadType?.name}
                        </h3>
                    {" "}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {
                            !!uploadType?.uploads?.length && uploadType?.uploads.map((file, index ) => {
                                return <div className="mb-2">
                                    <Chip
                                        label={truncateFileName(file?.blob_id)}
                                        variant="outlined"
                                        onClick={()=>{handleSelectedFileDownload(file.container_id, file.blob_id)}}
                                    />
                                </div>
                            })
                        }
                    </div>
                    
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        id="modal-close-button"
                        style={{
                            color: "var(--maincolor)",
                            backgroundColor: "#E5F5FF",
                            borderColor: "transparent",
                            textTransform: "unset"
                        }}
                        onClick={() =>
                            toggleDocModal()
                        }
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DocModal